/**************************************************
 * Nombre:       Dialogo_Varietal_Fotos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import {subirImagenHostingFile} from "../../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../../Servicios/BD/borrarDoc";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Varietal from "../../Formularios/Varietales/Formulario_Varietal";
import Formulario_Categoria from "../../Formularios/Formulario_Categoria";
import Formulario_Varietal_Descripcion from "../../Formularios/Varietales/Formulario_Varietal_Descripcion";
import {
    subirMultiplesImagenHostingFile
} from "../../../Servicios/AlmacenamientoHosting/subirMultiplesImagenHostingFile";
import Formulario_Varietal_Fotos from "../../Formularios/Varietales/Formulario_Varietal_Fotos";

const Dialogo_Varietal_Fotos = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()
        iniciarCarga('Subiendo Datos')
        let doxImgs = await subirMultiplesImagenHostingFile(entidad.imgs)
        entidad.imgs = doxImgs.data

        iniciarCarga('Subiendo Datos')

        let dox = await guardarDoc('varietales', entidad)
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Varietal_Fotos props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>



        </Grid>
    )

}
export default Dialogo_Varietal_Fotos